import React from "react";
import * as ReactIcons from 'react-icons/hi'
import { useNavigate, useLocation } from 'react-router-dom';

type Props = {
    buttonText: string,
    iconName: keyof typeof ReactIcons;
    url: string | string[],
    iconColor?: string,
    textColor: string,
    selectedColor: string,
    verticalView?: boolean;
    sleek?: boolean;
    hideInDesktopView?: boolean;
}

const SidebarButton = (props: Props) => {

    const IconComponent = ReactIcons[props.iconName];
    const [isSelected, setIsSelected] = React.useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    React.useEffect(() => {
        console.log("props.url change")
        if (props.url){
            const path = location.pathname;
            console.log(location.pathname, props.url)
            if (typeof props.url === "string") {
                console.log("url...")
                setIsSelected(props.url===path)
            }
            else {
                setIsSelected(props.url.includes(path));
            }
        }
    }, [props.url, location.pathname])
    

    const handleClick = () => {
        const targetUrl = typeof(props.url) === "string" ? props.url : props.url[0];
        
        // Check if it's an external URL (more comprehensive check)
        const isExternal = targetUrl.startsWith('http://') || 
                        targetUrl.startsWith('https://') || 
                        targetUrl.startsWith('www.');
        
        if (isExternal) {
            // Ensure the URL has a protocol
            const fullUrl = targetUrl.startsWith('http') ? targetUrl : `https://${targetUrl}`;
            window.location.href = fullUrl;
        } else {
            // Use React Router navigation for internal links
            navigate(targetUrl);
        }
    };

    
    return (
        <div 
            className={`sidebar-button ${props.hideInDesktopView ? "hide-in-desktop-view" : "show"} ${props.sleek ? "sleek" : "extended"} ${props.verticalView ? "full-button-width" : ""} ${isSelected ?  "sidebar-button-selected app-primary-color-selected" : "app-primary-color"}}`}  
            onClick={handleClick}
        >
            <div>
                <div className={`button-icon ${props.sleek ? "sleek" : "extended"}`} style={{color: isSelected ? props.selectedColor : (props.iconColor || props.textColor)}}><IconComponent /></div>
                <span className={`button-text ${props.sleek ? "sleek" : "extended"}`} style={{color: isSelected ? props.textColor : props.textColor}}>{props.buttonText}</span>
            </div>
        </div>
    )
}

export default SidebarButton;